export class AnswerWithMoreInfoModel<TEntity = unknown> {
  answerState: AnswerStateEnum;
  navigateTo: NavigateToEnum;
  message: string;
  entity: TEntity;
}

export enum AnswerStateEnum {
  OK = 'OK',
  ERROR = 'ERROR'
}

export enum NavigateToEnum {
  none = 'none',
  goToErrorPage = 'goToErrorPage',
  goToThanksPage = 'goToThanksPage'
}
